angular.module('unica_relator.relator_services')

.factory('RelatorEditService', function ($http, getBaseApiURL) {

	var relatorEditService = {};

	relatorEditService.update = function (relatorData)
	{
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/relator/update/' + relatorData.id,
			data: relatorData
		}).then(function(result) {

			if ( result ) {
				return result.data.relator;
			}

		});
	};

	return relatorEditService;
});